import { render, staticRenderFns } from "./StreamRecording.vue?vue&type=template&id=038c53fb&scoped=true&"
import script from "./StreamRecording.vue?vue&type=script&lang=js&"
export * from "./StreamRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c53fb",
  null
  
)

export default component.exports